import {
    AGENCY_FLEX_INDICATOR,
    FLEX_INDICATOR_COLUMN_TO_DATA,
    PERIODS_TO_TEXT,
    resolveMetricDisplayName
} from "./components/dashboard/columns";

export const TODAY_CLICKS_INDICATOR = 'TODAY_CLICKS_INDICATOR';
export const TODAY_IMPRESSIONS_INDICATOR = 'TODAY_IMPRESSIONS_INDICATOR';
export const TODAY_COST_INDICATOR = 'TODAY_COST_INDICATOR';
export const TODAY_CONVERSIONS_INDICATOR = 'TODAY_CONVERSIONS_INDICATOR';
export const TODAY_CPC_INDICATOR = 'TODAY_CPC_INDICATOR';
export const TODAY_CPA_INDICATOR = 'TODAY_CPA_INDICATOR';
export const TODAY_CTR_INDICATOR = 'TODAY_CTR_INDICATOR';
export const TODAY_CPM_INDICATOR = 'TODAY_CPM_INDICATOR';
export const BUDGET_PROPORTIONAL_DAILY_INDICATOR = 'BUDGET_PROPORTIONAL_DAILY_INDICATOR';
export const COST_VS_PROJECTED_INDICATOR = 'COST_VS_PROJECTED_INDICATOR';
export const CURRENT_PERIOD_COST_VS_TIME_COMPLETION_INDICATOR = 'CURRENT_PERIOD_COST_VS_TIME_COMPLETION_INDICATOR';
export const ODS_VS_YESTERDAY_INDICATOR = 'ODS_VS_YESTERDAY_INDICATOR';
export const ODS_VS_TODAY_INDICATOR = 'ODS_VS_TODAY_INDICATOR';
export const ODS_VS_LAST_7_DAYS_INDICATOR = 'ODS_VS_LAST_7_DAYS_INDICATOR';
export const ODS_VS_PLATFORM_BUDGET_INDICATOR = 'ODS_VS_PLATFORM_BUDGET_INDICATOR';
export const CONVERSIONS_DAILY_INDICATOR = 'CONVERSIONS_DAILY_INDICATOR';
export const CURRENT_ROAS_VS_LAST_MONTH = 'CURRENT_ROAS_VS_LAST_MONTH';
export const CURRENT_ACOS_VS_LAST_MONTH = 'CURRENT_ACOS_VS_LAST_MONTH';
export const CURRENT_PERIOD_CPA_VS_THREE_PAST_PERIODS_CPA = 'CURRENT_PERIOD_CPA_VS_THREE_PAST_PERIODS_CPA';
export const CURRENT_PERIOD_CPA_VS_SIX_PAST_PERIODS_CPA = 'CURRENT_PERIOD_CPA_VS_SIX_PAST_PERIODS_CPA';
export const CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA = 'CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA';
export const YESTERDAY_CPA_VS_THREE_PAST_PERIODS_CPA = 'YESTERDAY_CPA_VS_THREE_PAST_PERIODS_CPA';
export const YESTERDAY_CPA_VS_SIX_PAST_PERIODS_CPA = 'YESTERDAY_CPA_VS_SIX_PAST_PERIODS_CPA';
export const YESTERDAY_CPA_VS_LAST_PERIOD_CPA = 'YESTERDAY_CPA_VS_LAST_PERIOD_CPA';
export const FUNDS_INDICATOR = 'FUNDS_INDICATOR';
export const GOAL_1_INDICATOR = 'GOAL_1_INDICATOR';
export const GOAL_2_INDICATOR = 'GOAL_2_INDICATOR';
export const EXCEED_BUDGET_INDICATOR = 'EXCEED_BUDGET_INDICATOR';
// Lo que la regla de campañas de una línea deja afuera, contra su presupuesto (tanda «Control de líneas»,
// 15/10). Sólo lo configura el Centro de Alertas: NO va en `BUDGET_INDICATORS`, que es la lista que dibuja
// la pantalla clásica de sensibilidades.
export const UNCOVERED_SPEND_INDICATOR = 'UNCOVERED_SPEND_INDICATOR';

export const TODAY_INDICATOR_NAMES = [
    TODAY_CLICKS_INDICATOR,
    TODAY_IMPRESSIONS_INDICATOR,
    TODAY_COST_INDICATOR,
    TODAY_CONVERSIONS_INDICATOR,
    TODAY_CPC_INDICATOR,
    TODAY_CPA_INDICATOR,
    TODAY_CTR_INDICATOR,
    TODAY_CPM_INDICATOR
];

export const CPA_INDICATORS = [
    YESTERDAY_CPA_VS_THREE_PAST_PERIODS_CPA,
    YESTERDAY_CPA_VS_SIX_PAST_PERIODS_CPA,
    YESTERDAY_CPA_VS_LAST_PERIOD_CPA,
    CURRENT_PERIOD_CPA_VS_THREE_PAST_PERIODS_CPA,
    CURRENT_PERIOD_CPA_VS_SIX_PAST_PERIODS_CPA,
    CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA,
];

export const BUDGET_INDICATORS = [
    BUDGET_PROPORTIONAL_DAILY_INDICATOR,
    COST_VS_PROJECTED_INDICATOR,
    CURRENT_PERIOD_COST_VS_TIME_COMPLETION_INDICATOR,
    ODS_VS_YESTERDAY_INDICATOR,
    ODS_VS_TODAY_INDICATOR,
    ODS_VS_LAST_7_DAYS_INDICATOR,
    ODS_VS_PLATFORM_BUDGET_INDICATOR,
    EXCEED_BUDGET_INDICATOR
];

export const CONVERSIONS_INDICATORS = [
    CONVERSIONS_DAILY_INDICATOR,
    CURRENT_ROAS_VS_LAST_MONTH,
    CURRENT_ACOS_VS_LAST_MONTH
].concat(CPA_INDICATORS);

export const FUNDS_INDICATORS = [FUNDS_INDICATOR];

export const GOALS_INDICATORS = [GOAL_1_INDICATOR, GOAL_2_INDICATOR]

export const getIndicatorsData = (t) => ({
    [TODAY_CLICKS_INDICATOR]: {
        title: t('indicators.today_clicks'),
        subtitle: '',
        sensitivity_unit: '%'
    },
    [TODAY_IMPRESSIONS_INDICATOR]: {
        title: t('indicators.today_impressions'),
        subtitle: '',
        sensitivity_unit: '%'
    },
    [TODAY_COST_INDICATOR]: {
        title: t('indicators.today_cost'),
        subtitle: '',
        sensitivity_unit: '%'
    },
    [TODAY_CONVERSIONS_INDICATOR]: {
        title: t('indicators.today_conversions'),
        subtitle: '',
        sensitivity_unit: '%'
    },
    [TODAY_CPC_INDICATOR]: {
        title: t('indicators.today_cpc'),
        subtitle: '',
        sensitivity_unit: '%'
    },
    [TODAY_CPA_INDICATOR]: {
        title: t('indicators.today_cpa'),
        subtitle: '',
        sensitivity_unit: '%'
    },
    [TODAY_CTR_INDICATOR]: {
        title: t('indicators.today_ctr'),
        subtitle: '',
        sensitivity_unit: '%'
    },
    [TODAY_CPM_INDICATOR]: {
        title: t('indicators.today_cpm'),
        subtitle: '',
        sensitivity_unit: '%'
    },
    [BUDGET_PROPORTIONAL_DAILY_INDICATOR]: {
        title: t('indicators.budget_proportional_daily'),
        subtitle: t('indicators.vs_assigned_budget'),
        sensitivity_unit: '%'
    },
    [COST_VS_PROJECTED_INDICATOR]: {
        title: t('indicators.cost_vs_projected'),
        subtitle: t('indicators.cost_vs_projected_subtitle'),
        sensitivity_unit: '%'
    },
    [CURRENT_PERIOD_COST_VS_TIME_COMPLETION_INDICATOR]: {
        title: t('columns.current_period_cost_vs_time.title'),
        subtitle: t('indicators.current_period_cost_vs_time_subtitle'),
        sensitivity_unit: '%'
    },
    [ODS_VS_YESTERDAY_INDICATOR]: {
        title: t('indicators.ideal_daily_cost'),
        subtitle: t('indicators.vs_yesterday'),
        sensitivity_unit: '%'
    },
    [ODS_VS_LAST_7_DAYS_INDICATOR]: {
        title: t('indicators.ideal_daily_cost'),
        subtitle: t('indicators.vs_last_7_days_average'),
        sensitivity_unit: '%'
    },
    [ODS_VS_TODAY_INDICATOR]: {
        title: t('indicators.ideal_daily_cost'),
        subtitle: t('indicators.vs_today'),
        sensitivity_unit: '%'
    },
    [ODS_VS_PLATFORM_BUDGET_INDICATOR]: {
        title: t('indicators.ideal_daily_cost'),
        subtitle: t('indicators.vs_platform_budget'),
        sensitivity_unit: '%'
    },
    [CONVERSIONS_DAILY_INDICATOR]: {
        title: t('indicators.conversions'),
        subtitle: t('indicators.vs_last_month'),
        sensitivity_unit: '%'
    },
    [CURRENT_ROAS_VS_LAST_MONTH]: {
        title: t('indicators.roas'),
        subtitle: t('indicators.vs_last_month'),
        sensitivity_unit: '%'
    },
    [CURRENT_ACOS_VS_LAST_MONTH]: {
        title: t('indicators.acos'),
        subtitle: t('indicators.vs_last_month'),
        sensitivity_unit: '%'
    },
    [YESTERDAY_CPA_VS_THREE_PAST_PERIODS_CPA]: {
        title: t('indicators.yesterday_cpa'),
        subtitle: t('indicators.vs_last_3_months'),
        sensitivity_unit: '%'
    },
    [YESTERDAY_CPA_VS_SIX_PAST_PERIODS_CPA]: {
        title: t('indicators.yesterday_cpa'),
        subtitle: t('indicators.vs_last_6_months'),
        sensitivity_unit: '%'
    },
    [YESTERDAY_CPA_VS_LAST_PERIOD_CPA]: {
        title: t('indicators.yesterday_cpa'),
        subtitle: t('indicators.vs_last_month'),
        sensitivity_unit: '%'
    },
    [CURRENT_PERIOD_CPA_VS_THREE_PAST_PERIODS_CPA]: {
        title: t('indicators.current_month_cpa'),
        subtitle: t('indicators.vs_last_3_months'),
        sensitivity_unit: '%'
    },
    [CURRENT_PERIOD_CPA_VS_SIX_PAST_PERIODS_CPA]: {
        title: t('indicators.current_month_cpa'),
        subtitle: t('indicators.vs_last_6_months'),
        sensitivity_unit: '%'
    },
    [CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA]: {
        title: t('indicators.current_month_cpa'),
        subtitle: t('indicators.vs_last_month'),
        sensitivity_unit: '%'
    },
    [FUNDS_INDICATOR]: {
        title: t('indicators.days_until_balance_exhausted'),
        subtitle: '',
        sensitivity_unit: t('indicators.days')
    },
    [GOAL_1_INDICATOR]: {
        title: t('indicators.primary_goal'),
        subtitle: '',
        sensitivity_unit: '%'
    },
    [GOAL_2_INDICATOR]: {
        title: t('indicators.secondary_goal'),
        subtitle: '',
        sensitivity_unit: '%'
    },
    [EXCEED_BUDGET_INDICATOR]: {
        title: t('indicators.investment_warning'),
        subtitle: t('indicators.budget_consumed_percentage'),
        badLabel: t('indicators.first_warning'),
        criticalLabel: t('indicators.second_warning'),
        sensitivity_unit: '%'
    },
    [UNCOVERED_SPEND_INDICATOR]: {
        title: t('indicators.uncovered_spend'),
        subtitle: t('indicators.vs_assigned_budget'),
        sensitivity_unit: '%'
    }
});

// Keep the old export for backward compatibility
export const INDICATORS_DATA = getIndicatorsData;

export const getIndicatorData = (indicatorId, t) => {

    if(indicatorId.includes(AGENCY_FLEX_INDICATOR)) {
        const columnRawData = FLEX_INDICATOR_COLUMN_TO_DATA(indicatorId);

        return {
            'title': resolveMetricDisplayName(columnRawData["metricName"]),
            'subtitle': PERIODS_TO_TEXT(columnRawData["mainPeriod"], columnRawData["vsPeriod"]),
            'helper': t('indicators.flex_indicator_helper'),
            'sensitivity_unit': '%'
        };
    }

    return getIndicatorsData(t)[indicatorId];
};

// Keep the old export for backward compatibility
export const GET_INDICATOR_DATA = getIndicatorData;
